<!-- src/components/Cover.svelte — 從 JSON 讀內容 -->
<script>
  import ContentDataStore from '../stores/ContentDataStore.js'
  $: cover = $ContentDataStore?.cover || {}
</script>

{#if cover.title}
  <section class="cover">
    {#if cover.eyebrow}<div class="eyebrow">{cover.eyebrow}</div>{/if}
    <h1>{cover.title}</h1>
    {#if cover.subtitle}<p class="subtitle">{@html cover.subtitle}</p>{/if}
    {#if cover.scroll_hint}<div class="scroll-hint">{cover.scroll_hint}</div>{/if}
  </section>
{/if}

<style>
  .cover {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 2rem;
    color: var(--color-text, #222222);
    font-family: 'Noto Sans TC', sans-serif;
  }
  .eyebrow {
    font-size: 0.9rem;
    color: var(--color-accent, #d44545);
    letter-spacing: 0.4em;
    margin-bottom: 2rem;
    font-weight: 600;
  }
  h1 {
    font-size: clamp(2.5rem, 8vw, 6rem);
    letter-spacing: 0.15em;
    margin-bottom: 1.5rem;
    font-weight: 700;
    color: var(--color-text, #222222);
  }
  .subtitle {
    color: var(--color-text-dim, #777777);
    max-width: 540px;
    line-height: 1.9;
    font-size: 1.05rem;
  }
  .scroll-hint {
    margin-top: 3rem;
    color: var(--color-text-dim, #777777);
    font-size: 0.85rem;
    animation: bob 2s ease-in-out infinite;
  }
  @keyframes bob {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(6px); }
  }
</style>
